import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=16f9050b&scoped=true&"
var script = {}
import style0 from "./Tag.vue?vue&type=style&index=0&id=16f9050b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f9050b",
  null
  
)

export default component.exports